import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../utils/animationVariants';
import ProductList from '../components/ProductList';
import {
  animal_products_with_slug as animal_products,
  categories,
  IMAGE_BASE_PATH,
} from '../assets/data/animal_prod';

function Animal() {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <ProductList
        products={animal_products.map((product) => ({
          ...product,
          image: `${IMAGE_BASE_PATH}${product.image}`, // 이미지 경로 완성
        }))}
        categories={categories}
        basePath="animal"
      />
    </motion.div>
  );
}

export default Animal;
